import { render, staticRenderFns } from "./TailorModal.vue?vue&type=template&id=473c776d&"
import script from "./TailorModal.vue?vue&type=script&lang=js&"
export * from "./TailorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports